import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Form,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  TextAreaInput,
  TextInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { FormListWrapper, DeleteContainer, SkillItemContainer } from './skills.styles';


const Skills = () => {
  const { t } = useTranslation('employee');

  return (
    <Form.List name={['educationAndSkills', 'skills']} initialValue={[{}]}>
      {(fields, { add, remove }) => (
        <FormListWrapper isIcon={fields.length > 1}>
          <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {t('employee:educationsAndSkills.labels.skills')}
          </Typography>
          <div>
            {fields.map(field => (
              <SkillItemContainer key={field.key} className={'test'}>
                <DeleteContainer isIcon={fields.length > 1}>
                  <Form.Item
                    name={[field.name, 'name']}
                    label={t('employee:educationsAndSkills.labels.skillsName')}
                  >
                    <TextInput maxLength={50} placeholder={t('employee:labels.startTyping')} />
                  </Form.Item>
                  {fields.length > 1 && (
                    <Icon
                      icon={ICONS.trash}
                      rightMargin={false}
                      color={PLATFORM_THEME_COLORS.tone.red}
                      size={22}
                      onClick={() => remove(field.name)}
                    />
                  )}
                </DeleteContainer>
                <Form.Item
                  name={[field.name, 'description']}
                  label={t('common:labels.description')}
                >
                  <TextAreaInput
                    showCount
                    maxLength={500}
                    placeholder={t('products:planList.createPlan.placeholders.writeDescription')}
                  />
                </Form.Item>
              </SkillItemContainer>
            ))}
          </div>
          <Button
            type="text"
            icon={ICONS.plus}
            iconColor={PLATFORM_THEME_COLORS.primary.blue}
            onClick={() => add()}
          >
            {t('employee:educationsAndSkills.buttons.addNewSkill')}
          </Button>
        </FormListWrapper>
      )}
    </Form.List>
  );
};

export default Skills;
